import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import { InstallableDetail, InstallableDetailVariables } from './__generated__/InstallableDetail'
import { InstallableDefinition, InstallableDefinitionVariables } from './__generated__/InstallableDefinition'

const QUERY = gql`
  query InstallableDetail($id: String!) {
    developers {
      id
      created
      title
    }
    installable(id: $id) {
      id
      title
      created
      description
      icon
      hideFromInstallablesList
      installationsAreSingleton
      configurationSchema
      subscriptionsCanBeRenamed
      cadenceConfigurationUrl
      cadenceDisplayTemplate
      cadenceToken
      readyForReactNative
      cadenceOnCommand
      webhookDestination {
        id
        url
      }
      subscriptionConfigurationUrl
      developer {
        id
        title
      }
    }
  }
`

const DEFINITION_QUERY = gql`
  query InstallableDefinition($installableId: String!) {
    installableDefinitionV2(installableId: $installableId) {
      ... on InstallableDefinitionV2 {
        installableId
        definitionJson
      }
      ... on InstallableErrorV2 {
        type
        error
      }
    }
  }
`

export const useGetInstallable = (id: string) => {
  return useQuery<InstallableDetail, InstallableDetailVariables>(QUERY, {
    variables: {
      id
    }
  })
}

export const useGetInstallableDefinition = (variables: InstallableDefinitionVariables) => {
  return useQuery<InstallableDefinition, InstallableDefinitionVariables>(DEFINITION_QUERY, {
    variables
  })
}
